import type { InventoryAndIntakeValues } from "@slfinrtl/ui-bff-routes"
import type { DatePickerFieldProps } from "src/components/form/datepicker/DatepickerField"
import type { InputFieldProps } from "src/components/form/input/InputField"
import type { RadioGroupFieldProps } from "src/components/form/radio/radioGroup/RadioGroupField"
import type { SelectFieldProps } from "src/components/form/select/SelectField"

export interface InventoryAndIntakeFields {
	arrivalDate: DatePickerFieldProps
	availableForCustomerFromDate: DatePickerFieldProps
	availableFromDate?: DatePickerFieldProps
	expectedArrivalDate?: DatePickerFieldProps
	inventoryNumber: InputFieldProps
	licensePlate: InputFieldProps
	masterNumberCh?: InputFieldProps
	mileageAccordingToPreviousOwner: InputFieldProps
	stockStatus: RadioGroupFieldProps
	typeKeyNumber: InputFieldProps
	vehicleOrigin: SelectFieldProps
	vehicleType: RadioGroupFieldProps
}

type FieldName = keyof InventoryAndIntakeValues

const vehicleTypeName: FieldName = "vehicleType"
const stockStatusName: FieldName = "stockStatus"
const inventoryNumberName: FieldName = "inventoryNumber"
const typeKeyNumberName: FieldName = "typeKeyNumber"
const masterNumberChName: FieldName = "masterNumberCh"
const licensePlateName: FieldName = "licensePlate"
const availableFromDateName: FieldName = "availableFromDate"
const expectedArrivalDateName: FieldName = "expectedArrivalDate"
const vehicleOriginName: FieldName = "vehicleOrigin"
const arrivalDateName: FieldName = "arrivalDate"
const mileageAccordingToPreviousOwnerName: FieldName = "mileageAccordingToPreviousOwner"
const availableForCustomerFromDateName: FieldName = "availableForCustomerFromDate"

export const inventoryAndIntakeFieldNames = {
	arrivalDateName,
	availableForCustomerFromDateName,
	availableFromDateName,
	expectedArrivalDateName,
	inventoryNumberName,
	licensePlateName,
	masterNumberChName,
	mileageAccordingToPreviousOwnerName,
	stockStatusName,
	typeKeyNumberName,
	vehicleOriginName,
	vehicleTypeName,
}
